import CryptoJs from 'crypto-js'

export function md5(str) {
  return CryptoJs.MD5(str).toString();
}

export function encryptDES(str){
  let aStrKey='cool@$#@'
  let ivstr='88888888'
  const KeyHex = CryptoJs.enc.Utf8.parse(aStrKey);
  const encrypted = CryptoJs.TripleDES.encrypt(str,
    KeyHex,
    {
      mode: CryptoJs.mode.CBC,
      padding: CryptoJs.pad.Pkcs7,
      iv: CryptoJs.enc.Utf8.parse(ivstr)
    });
  let hexstr = encrypted.ciphertext.toString().toUpperCase();
  //console.log(hexstr);
  return hexstr;
}

export function decryptDES (str) {
  let aStrKey='cool@$#@'
  let ivstr='88888888'
  const KeyHex = CryptoJs.enc.Utf8.parse(aStrKey);
  //因为我们加密的时候用到的16进制字符串，需要进行转换
  //第一步把16进制字符串转为WordArray格式
  const WordArray = CryptoJs.enc.Hex.parse(str);
  //第二步把WordArray再转为base64的字符串
  const base64str = CryptoJs.enc.Base64.stringify(WordArray);
  //第三步再进行解密
  const decrypted = CryptoJs.TripleDES.decrypt(base64str,
    KeyHex,
    {
      mode: CryptoJs.mode.CBC,
      padding: CryptoJs.pad.Pkcs7,
      iv: CryptoJs.enc.Utf8.parse(ivstr)
    });

  return decrypted.toString(CryptoJs.enc.Utf8);
}



// WEBPACK FOOTER //
// ./src/service/cryptoUtil.js